
import { defineCborSchema, CborField, type CborSchema } from '@mesh/friendly-cbor-serializer'
import { Id } from '../aliases'

export type ImageObject = {
  id?: Id
  name: string
  imageUrl: string
}

export const ImageObjectSchema: CborSchema<ImageObject> = defineCborSchema<ImageObject>({
  id: CborField({ key: 0, required: false }),
  name: CborField({ key: 1 }),
  imageUrl: CborField({ key: 3 }),
})
